import { render, staticRenderFns } from "./Simples.vue?vue&type=template&id=54493ec4&scoped=true&"
import script from "./Simples.vue?vue&type=script&lang=js&"
export * from "./Simples.vue?vue&type=script&lang=js&"
import style0 from "./Simples.vue?vue&type=style&index=0&id=54493ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54493ec4",
  null
  
)

export default component.exports